// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"loading_loader_container__3JHmE","loader":"loading_loader__1ViEP"};